//#region Imports
import PropTypes from 'prop-types';
import { Map as ImmutableMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { StepIndicator } from 'foundations-components/transitional/components/StepIndicator';
import { Text } from 'foundations-components/components/Text';
import { BOOKING_STEPS } from 'MeetingsLib/constants/steps';
//#endregion Imports
import { jsx as _jsx } from "react/jsx-runtime";
const stepKeys = ImmutableMap(BOOKING_STEPS);
const BookingStepIndicator = ({
  compact,
  currStep,
  embedded,
  isPreviewed = false,
  withPayment = false
}) => {
  const steps = (withPayment ? stepKeys : stepKeys.butLast()).valueSeq().toArray();
  const stepNames = steps.map(stepName => {
    const message = `stepIndicator.${stepName}`;
    return /*#__PURE__*/_jsx(Text, {
      as: "p",
      textTransform: "uppercase",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: message
      }, message)
    }, message);
  });
  let stepIndex = steps.indexOf(currStep);
  if (stepIndex === -1) {
    stepIndex = steps.length;
  }
  if (compact || embedded || isPreviewed) return null;
  return /*#__PURE__*/_jsx(TFlex, {
    justify: "center",
    marginInline: "auto",
    maxInlineSize: withPayment ? '940px' : '540px',
    children: /*#__PURE__*/_jsx(StepIndicator, {
      stepNames: stepNames,
      stepIndex: stepIndex,
      marginBlockStart: "800"
    })
  });
};
export default BookingStepIndicator;
BookingStepIndicator.propTypes = {
  compact: PropTypes.bool.isRequired,
  currStep: PropTypes.string,
  embedded: PropTypes.bool.isRequired,
  isPreviewed: PropTypes.bool,
  withPayment: PropTypes.bool
};